import React from 'react'
import { UncontrolledAlert } from 'reactstrap'

const AlertaGuardado = ({status}) => {
  return (
    
        <div className="mt-3">
        {status === "saved" ? (
          <UncontrolledAlert color="success" fade={true}>
            <span className="alert-inner--icon">
              <i className="ni ni-like-2" />
            </span>{" "}
            <span className="alert-inner--text">
              <strong>¡Guardado!</strong> Se ha guardado correctamente
            </span>
          </UncontrolledAlert>
        ) : (
          ""
        )}
        {status === "not found" ? (
          <UncontrolledAlert color="warning" fade={true}>
            <span className="alert-inner--icon">
              <i className="ni ni-fat-remove" />
            </span>{" "}
            <span className="alert-inner--text">
              <strong>¡No encontrado!</strong> No se ha encontrado elemento.
            </span>
          </UncontrolledAlert>
        ) : (
          ""
        )}

        {status === "error" ? (
          <UncontrolledAlert color="danger" fade={true}>
            <span className="alert-inner--icon">
              <i className="ni ni-fat-remove" />
            </span>{" "}
            <span className="alert-inner--text">
              <strong>¡Error!</strong> Se ha producido un error.
            </span>
          </UncontrolledAlert>
        ) : (
          ""
        )}
      </div>
    
  )
}

export default AlertaGuardado